import { useFindOneContactSentimentByChat } from 'hooks/contact-sentiments';
import { useFindContactByChatQuery } from 'services';
import { ContactDto } from 'types';

export function useContactDetailByChat(chatId?: number) {
  const { data: contactRes, isLoading } = useFindContactByChatQuery(chatId!, {
    skip: !chatId,
    refetchOnMountOrArgChange: true
  });

  const { contactSentiment, isLoadingContactSentiment } = useFindOneContactSentimentByChat(
    {
      chatId: chatId!
    },
    {
      skip: !chatId
    }
  );

  return {
    contact: contactRes?.data
      ? ({
          ...contactRes.data,
          contactSentiment: contactSentiment || undefined
        } as ContactDto)
      : undefined,
    isLoading,
    isLoadingContactSentiment
  };
}
